import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { AuthenticatedUser } from 'src/app/shared/models';
import { AuthenticationService, LOCAL, StorageService } from 'src/app/shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [
        style({ opacity: 1, 'max-width': '100%' }),
        animate('200ms ease-out', style({ opacity: 0, width: 0 })),
      ]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  public complete$ = new Subject();

  public isLoading = false;

  public showSidenav = true;

  public user$: Observable<AuthenticatedUser | null>;

  constructor(public readonly authenticationService: AuthenticationService, private readonly router: Router, 
    private readonly storageService: StorageService, private readonly keycloak: KeycloakService) {
    if (window.innerWidth <= 800) {
      this.showSidenav = false;
    }
  }

  public ngOnDestroy() {
    this.complete$.next();

    this.complete$.complete();
  }

  public ngOnInit(): void {
    if(this.storageService.getItem(LOCAL.CURRENT_USER) || 
    this.storageService.getItem(LOCAL.ROLE_USER) || 
    this.storageService.getItem(LOCAL.RESPONSE_GROUP_USER)){
      this.keycloak.isLoggedIn().then(data => {
        if(!data){
          localStorage.clear();
          sessionStorage.clear();
          this.authenticationService.user.next(null);
          this.navLogic();
        }
        else{
          this.authenticationService.decodeToken().then(async data => {
            if(data.sid != this.storageService.getItem(LOCAL.SESSID)){
              localStorage.clear();
              sessionStorage.clear();
              const userRoles = await this.authenticationService.getUserRoles().pipe(map(response => {return response})).toPromise();
              this.authenticationService.userData(null, userRoles);
              this.storageService.setItem(LOCAL.SESSID, data.sid);
            }
            this.navLogic();
          }); 
        }
      })
    }
    else{
      this.navLogic();
    }
  }

  navLogic(){
    this.user$ = this.authenticationService.user$;
    this.router.events
    .pipe(
      filter(
        event =>
          event instanceof NavigationEnd ||
          event instanceof NavigationStart ||
          event instanceof NavigationError ||
          event instanceof NavigationCancel
      ),
      takeUntil(this.complete$)
    )
    .subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    });
  }

  public onToggleSidenav(): void {
    this.showSidenav = !this.showSidenav;
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize(event: any) {
    if (event.target.innerWidth <= 800) {
      this.showSidenav = false;
    } else {
      this.showSidenav = true;
    }
  }
}
